<template>
  <div>
    <app-bar
      title="KKP (Kartu Kontrol Pasien)"
      :noDivider="true"
      :previousLink="{ name: 'ProfilOfflineOrderDetail', params: { id_order: $route.params.id_order } }" />

    <div class="container">
      <Loading v-if="loading.listKkp" />

      <div v-else-if="listKkpOffline.length === 0" class="d-flex align-items-center justify-content-center" style="height: 20rem">
        <div class="d-flex flex-column align-items-center">
          <div class="mb-4">
            <img src="@/assets/icon/not-found.png" alt="">
          </div>
          <div class="fm-poppins text-title-active fw-600 fs-32">Tidak Ada Data</div>
        </div>
      </div>

      <div v-else class="row">
        <div class="col-md-7 px-0">
          <div
            v-for="kkp in listKkpOffline"
            :key="kkp.kkp"
            class="card-info d-flex flex-column px-3 pb-3 mb-3">
            <div class="group-item d-flex flex-row py-3">
              <div :id="'barcode-' + kkp.kkp" class="px-2" style="flex: none"></div>
              <div class="d-flex flex-column ps-1 py-1 justify-content-between">
                <p class="text-title-active fm-poppins fst-normal fw-500 fs-16 lh-14 mb-0">
                  {{ kkp.nama }}
                </p>
                <div
                  v-if="kkp.status"
                  class="badge bg-success-disable text-success py-2"
                  style="border-radius: 8px; width: fit-content">
                  Selesai
                </div>
                <div
                  v-else
                  class="badge bg-warning-disable text-warning py-2"
                  style="border-radius: 8px; width: fit-content">
                  Belum Dilakukan
                </div>
              </div>
            </div>
            <div
              role="button"
              @click="openQrModal(kkp)"
              class="btn btn-next bg-primary w-100 pt-2 pb-2">
              <p class="text-white fm-nunito fst-normal fw-600 fs-14 lh-19 m-0">Lihat QR Code</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal QR Code -->
    <div class="modal fade" id="modalQrCodeOffline" tabindex="-1" aria-labelledby="modalQrCodeOffline" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body d-flex flex-column text-center px-3">
            <div class="img-qrcode p-3 d-flex justify-content-center" id="modal-qrcode-offline"></div>
            <button type="button" class="btn btn-primary py-2" data-bs-dismiss="modal">Tutup</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
  </div>
</template>

<script>
import { getListKkpOffline, listKkpOffline, loading } from '@/core/profile'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AppBar from '@/components/AppBar.vue'
import Loading from '@/components/utility/Loading.vue'
import { Modal } from 'bootstrap'
import { qrcanvas } from 'qrcanvas'

export default {
  components: { AppBar, Loading },
  setup () {
    const route = useRoute()
    const selectedKkp = ref(null)
    let modalInstance = null

    const generateQrThumbnails = () => {
      for (const kkp of listKkpOffline.value) {
        const el = document.getElementById('barcode-' + kkp.kkp)
        if (!el) continue
        el.innerHTML = ''
        el.appendChild(qrcanvas({
          cellSize: 3,
          data: kkp.kkp,
          foreground: [{ style: '#007A98' }]
        }))
      }
    }

    onMounted(async () => {
      await getListKkpOffline({ id: route.params.id_order })
      modalInstance = new Modal(document.querySelector('#modalQrCodeOffline'))
      generateQrThumbnails()
    })

    const openQrModal = (kkp) => {
      selectedKkp.value = kkp
      const modal = document.getElementById('modal-qrcode-offline')
      modal.innerHTML = ''
      modal.appendChild(qrcanvas({
        cellSize: 13,
        data: kkp.kkp,
        foreground: [{ style: '#007A98' }]
      }))
      modalInstance.show()
    }

    return {
      listKkpOffline,
      loading,
      selectedKkp,
      openQrModal
    }
  }
}
</script>

<style lang="scss" scoped>
.card-info {
  border: 1px solid #EFF0F7;
  box-sizing: border-box;
  border-radius: 10px;
}
</style>
